const getZoom = (desktopZoom, mobileZoom) => {
  const mq = window.matchMedia('(max-width: 768px)');
  let zoom = desktopZoom;
  if (mq && mq.matches) {
    zoom = mobileZoom;
  }
  return zoom;
};

export { getZoom };